import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import PremiumLanding from './premium/PremiumLanding';
import './premium/premium.css';

export default function LandingPage() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    document.documentElement.classList.add('nsara-premium-document');
    return () => document.documentElement.classList.remove('nsara-premium-document');
  }, []);
  const followLocalRoute = event => {
    const link = event.target.closest('a[href]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const href = link.getAttribute('href');
    if (!['/login', '/register', '/dashboard'].includes(href)) return;
    event.preventDefault();
    navigate(href);
  };
  return <div className="nsara-premium" onClick={followLocalRoute}><PremiumLanding authenticated={Boolean(currentUser)} /></div>;
}
